import type { AIModel } from '@/api/types'
import type { ProtoDropdownOption } from '@/features/studio/components/ui-kit'

type CanvasT = (key: string, opts?: Record<string, unknown>) => string

/** 画布模型下拉：名称 + 独立积分 badge，避免紧凑布局截断 */
export function buildCanvasModelOptions(models: AIModel[], t: CanvasT): ProtoDropdownOption[] {
  return models.map((m) => ({
    value: m.id,
    label: m.name,
    badge: t('canvas.modelCost', { cost: m.cost }),
  }))
}
